import React, { useState } from "react";
import { fileUrl } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Eye, EyeOff, AlertTriangle, Maximize2, Check } from "lucide-react";

export function RenderCard({ render, originalPath, onSelect, selected }) {
  const [showOriginal, setShowOriginal] = useState(false);
  const [zoom, setZoom] = useState(false);
  const src = render.ok && render.storage_path ? fileUrl(render.storage_path) : null;
  const orig = originalPath ? fileUrl(originalPath) : null;

  return (
    <div
      data-testid={`render-card-${render.style_key}`}
      className={`rounded-2xl overflow-hidden border transition-all ${
        selected ? "border-primary glow-red" : "border-slate-800 hover:border-slate-700"
      } bg-card`}
    >
      <div className="relative aspect-[4/3] bg-slate-900 overflow-hidden">
        {src ? (
          <>
            <img
              src={showOriginal ? orig : src}
              alt={render.label}
              className="w-full h-full object-cover"
            />
            <div className="absolute top-2 left-2 flex gap-1.5">
              <Badge className="bg-black/70 text-white border-0 backdrop-blur text-[10px]">
                {showOriginal ? "ÎNAINTE" : "DUPĂ"}
              </Badge>
            </div>
            <div className="absolute top-2 right-2 flex gap-1.5">
              <button
                onClick={() => setZoom(true)}
                data-testid={`render-zoom-${render.style_key}`}
                className="w-8 h-8 rounded-lg bg-black/60 backdrop-blur flex items-center justify-center text-white hover:bg-black/80"
              >
                <Maximize2 className="w-4 h-4" />
              </button>
            </div>
            <button
              onMouseDown={() => setShowOriginal(true)}
              onMouseUp={() => setShowOriginal(false)}
              onMouseLeave={() => setShowOriginal(false)}
              onTouchStart={() => setShowOriginal(true)}
              onTouchEnd={() => setShowOriginal(false)}
              data-testid={`render-compare-${render.style_key}`}
              className="absolute bottom-2 left-1/2 -translate-x-1/2 flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-black/70 backdrop-blur text-white text-xs font-medium hover:bg-black/90"
            >
              {showOriginal ? <EyeOff className="w-3.5 h-3.5" /> : <Eye className="w-3.5 h-3.5" />}
              Ține apăsat: original
            </button>
          </>
        ) : (
          <div className="w-full h-full flex flex-col items-center justify-center text-slate-500 gap-2 p-4 text-center">
            <AlertTriangle className="w-8 h-8 text-amber-500" />
            <span className="text-xs">Randarea nu a putut fi generată. Încearcă din nou.</span>
          </div>
        )}
      </div>

      <div className="p-4 space-y-3">
        <div>
          <h4 className="font-display font-semibold text-white text-base">{render.label}</h4>
          <p className="text-xs text-slate-400 mt-1 leading-relaxed">{render.desc}</p>
        </div>
        {src && onSelect && (
          <Button
            size="sm"
            onClick={() => onSelect(render.style_key)}
            data-testid={`render-select-${render.style_key}`}
            className={`w-full ${selected ? "bg-primary text-white" : "bg-slate-800 text-slate-200 hover:bg-slate-700"}`}
          >
            {selected ? <><Check className="w-4 h-4 mr-1.5" /> Selectat pentru ofertă</> : "Alege această variantă"}
          </Button>
        )}
      </div>

      {zoom && src && (
        <div
          className="fixed inset-0 z-[100] bg-black/95 flex items-center justify-center p-4"
          onClick={() => setZoom(false)}
          data-testid={`render-lightbox-${render.style_key}`}
        >
          <img src={src} alt={render.label} className="max-w-full max-h-full object-contain rounded-lg" />
        </div>
      )}
    </div>
  );
}
